import { RouteRecordRaw } from "vue-router";
import LoginPage from "@/views/v2/user/LoginPage.vue";

export const AuthRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Login",
    component: LoginPage,
    meta: {
      title: "Login"
    }
  },
];
